import React from 'react';
import axios, { AxiosError } from 'axios';
import { UserInput } from '../interface/interface';
import { IResponseGeneratorUser } from '../../../../interface/interfaces';
import { useAppDispatch } from '../../../../redux/hooks';
import toast from 'react-hot-toast';
import { saveUserAndTokenData } from '../login.slice';
import { useNavigate, useLocation } from 'react-router-dom';
import { ROUTES } from '../../../../constants/constants';

export const authenticateUser = async (
    setLoading: React.Dispatch<React.SetStateAction<boolean>>,
    values: UserInput,
    dispatch: ReturnType<typeof useAppDispatch>,
    navigate: ReturnType<typeof useNavigate>,
    location: ReturnType<typeof useLocation>,
) => {
    setLoading(true);
    try {
        // console.log('LOC FROM AUTHENTIFICATEUSER UTILS: ', location)
        const fetchLoginUser = (await axios.post(`${process.env.REACT_APP_USER_API}/Login`, values, {
            headers: {
                'Content-Type': 'application/json',
            },
        })) as IResponseGeneratorUser;

        const loginUserData = fetchLoginUser.data;
        dispatch(saveUserAndTokenData(loginUserData));

        toast.success(
            <p>
                <span style={{ fontWeight: 'bold' }}>
                    {loginUserData.user.name} {loginUserData.user.surname}
                </span>{' '}
                successfully loged in.
            </p>,
        );

        setLoading(false);

        navigate(location.state || `/${ROUTES.PROJECTS}`);
    } catch (err) {
        if (err instanceof AxiosError) {
            toast.error(`Authentification failed.`);
            // toast.error(`${err.message}`);
        } else {
            toast.error('Something went wrong with authentification.');
        }
    } finally {
        setLoading(false);
    }
};
